import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39537ac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "card-body py-3" }

import { textSearch } from "@/assets/ts/_utils";
import JsonExcel from "@/components/widgets/tables/JsonExcel.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { SortProps, sortFn } from "@/core/helpers/sort";
import Page from "@/layout/Page.vue";
import { Justificacion2025Module } from "@/store/modules/Justificacion2025Module";
import Swal from "sweetalert2";
import { computed, onActivated, onBeforeMount, onMounted, ref } from "vue";
import { useArrayPagination } from "vue-composable";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "justificacion2025-listado",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const module = getModule(Justificacion2025Module, store);

const justificaciones = computed(() => module.justificaciones);

// Computeds para los datos con campos calculados (para Excel y tabla)
const justificacionesConCalculados = computed(() =>
  justificaciones.value.map((item) => {
    const l1NoEjecutado =
      (item.l1CreditoComprometido || 0) - (item.l1CreditoEjecutado || 0);
    const l2NoEjecutado =
      (item.l2CreditoComprometido || 0) - (item.l2CreditoEjecutado || 0);
    const l3NoEjecutado =
      (item.l3CreditoComprometido || 0) - (item.l3CreditoEjecutado || 0);
    const l4NoEjecutado =
      (item.l4CreditoComprometido || 0) - (item.l4CreditoEjecutado || 0);
    const l5NoEjecutado =
      (item.l5CreditoComprometido || 0) - (item.l5CreditoEjecutado || 0);

    const totalComprometido =
      (item.l1CreditoComprometido || 0) +
      (item.l2CreditoComprometido || 0) +
      (item.l3CreditoComprometido || 0) +
      (item.l4CreditoComprometido || 0) +
      (item.l5CreditoComprometido || 0);

    const totalEjecutado =
      (item.l1CreditoEjecutado || 0) +
      (item.l2CreditoEjecutado || 0) +
      (item.l3CreditoEjecutado || 0) +
      (item.l4CreditoEjecutado || 0) +
      (item.l5CreditoEjecutado || 0);

    const totalNoEjecutado =
      l1NoEjecutado +
      l2NoEjecutado +
      l3NoEjecutado +
      l4NoEjecutado +
      l5NoEjecutado;

    return {
      ...item,
      comarcaNombre: item.comarca?.nombre,
      l1CreditoNoEjecutado: l1NoEjecutado,
      l2CreditoNoEjecutado: l2NoEjecutado,
      l3CreditoNoEjecutado: l3NoEjecutado,
      l4CreditoNoEjecutado: l4NoEjecutado,
      l5CreditoNoEjecutado: l5NoEjecutado,
      totalCreditoComprometido: totalComprometido,
      totalCreditoEjecutado: totalEjecutado,
      totalCreditoNoEjecutado: totalNoEjecutado,
    };
  })
);

// Computeds para totales
const totales = computed(() => {
  const data = justificacionesConCalculados.value;
  return {
    l1Comprometido: data.reduce(
      (sum, item) => sum + (item.l1CreditoComprometido || 0),
      0
    ),
    l1Ejecutado: data.reduce(
      (sum, item) => sum + (item.l1CreditoEjecutado || 0),
      0
    ),
    l1NoEjecutado: data.reduce(
      (sum, item) => sum + (item.l1CreditoNoEjecutado || 0),
      0
    ),
    l2Comprometido: data.reduce(
      (sum, item) => sum + (item.l2CreditoComprometido || 0),
      0
    ),
    l2Ejecutado: data.reduce(
      (sum, item) => sum + (item.l2CreditoEjecutado || 0),
      0
    ),
    l2NoEjecutado: data.reduce(
      (sum, item) => sum + (item.l2CreditoNoEjecutado || 0),
      0
    ),
    l3Comprometido: data.reduce(
      (sum, item) => sum + (item.l3CreditoComprometido || 0),
      0
    ),
    l3Ejecutado: data.reduce(
      (sum, item) => sum + (item.l3CreditoEjecutado || 0),
      0
    ),
    l3NoEjecutado: data.reduce(
      (sum, item) => sum + (item.l3CreditoNoEjecutado || 0),
      0
    ),
    l4Comprometido: data.reduce(
      (sum, item) => sum + (item.l4CreditoComprometido || 0),
      0
    ),
    l4Ejecutado: data.reduce(
      (sum, item) => sum + (item.l4CreditoEjecutado || 0),
      0
    ),
    l4NoEjecutado: data.reduce(
      (sum, item) => sum + (item.l4CreditoNoEjecutado || 0),
      0
    ),
    l5Comprometido: data.reduce(
      (sum, item) => sum + (item.l5CreditoComprometido || 0),
      0
    ),
    l5Ejecutado: data.reduce(
      (sum, item) => sum + (item.l5CreditoEjecutado || 0),
      0
    ),
    l5NoEjecutado: data.reduce(
      (sum, item) => sum + (item.l5CreditoNoEjecutado || 0),
      0
    ),
    // Totales de las columnas de agrupación general
    totalComprometido: data.reduce(
      (sum, item) => sum + (item.totalCreditoComprometido || 0),
      0
    ),
    totalEjecutado: data.reduce(
      (sum, item) => sum + (item.totalCreditoEjecutado || 0),
      0
    ),
    totalNoEjecutado: data.reduce(
      (sum, item) => sum + (item.totalCreditoNoEjecutado || 0),
      0
    ),
  };
});

// Exportar a Excel
const csvLabels = {
  comarcaNombre: t("tabla.justificacion2025.comarca"),
  totalCreditoComprometido: t(
    "tabla.justificacion2025.totalCreditoComprometido"
  ),
  totalCreditoEjecutado: t("tabla.justificacion2025.totalCreditoEjecutado"),
  totalCreditoNoEjecutado: t("tabla.justificacion2025.totalCreditoNoEjecutado"),
  l1CreditoComprometido: t("tabla.justificacion2025.l1CreditoComprometido"),
  l1CreditoEjecutado: t("tabla.justificacion2025.l1CreditoEjecutado"),
  l1CreditoNoEjecutado: t("tabla.justificacion2025.l1CreditoNoEjecutado"),
  l2CreditoComprometido: t("tabla.justificacion2025.l2CreditoComprometido"),
  l2CreditoEjecutado: t("tabla.justificacion2025.l2CreditoEjecutado"),
  l2CreditoNoEjecutado: t("tabla.justificacion2025.l2CreditoNoEjecutado"),
  l3CreditoComprometido: t("tabla.justificacion2025.l3CreditoComprometido"),
  l3CreditoEjecutado: t("tabla.justificacion2025.l3CreditoEjecutado"),
  l3CreditoNoEjecutado: t("tabla.justificacion2025.l3CreditoNoEjecutado"),
  l4CreditoComprometido: t("tabla.justificacion2025.l4CreditoComprometido"),
  l4CreditoEjecutado: t("tabla.justificacion2025.l4CreditoEjecutado"),
  l4CreditoNoEjecutado: t("tabla.justificacion2025.l4CreditoNoEjecutado"),
  l5CreditoComprometido: t("tabla.justificacion2025.l5CreditoComprometido"),
  l5CreditoEjecutado: t("tabla.justificacion2025.l5CreditoEjecutado"),
  l5CreditoNoEjecutado: t("tabla.justificacion2025.l5CreditoNoEjecutado"),
};
const csvFields = Object.keys(csvLabels);

const csvName = "justificacion2025Listado" + new Date().getTime() + ".xlsx";

// Búsqueda y ordenación
const search = ref("");
const sortProps = ref<SortProps>({
  prop: "comarca.nombre",
  order: "ascending",
  method: null,
});
const sortChange = ({ column, prop, order }) => {
  sortProps.value = { prop, order, method: column.sortMethod };
};
const filteredCollection = computed(() =>
  justificacionesConCalculados.value
    .slice()
    .sort(sortFn(sortProps))
    .filter((data) => {
      return (
        !search.value || textSearch(data.comarca?.nombre || "", search.value)
      );
    })
);

// Paginación
const { result, currentPage } = useArrayPagination(filteredCollection, {
  pageSize: 25,
});

const handleCurrentPageChange = (page: number) => (currentPage.value = page);

const formatCurrency = (value: number | null | undefined): string => {
  const numValue = value || 0;
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numValue);
};

const getSummaries = (param: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any[];
  data: Array<Record<string, unknown>>;
}) => {
  const { columns } = param;
  const summaryRow: Array<string> = [];

  const totalesMap: Record<string, number> = {
    l1CreditoComprometido: totales.value.l1Comprometido,
    l1CreditoEjecutado: totales.value.l1Ejecutado,
    l1CreditoNoEjecutado: totales.value.l1NoEjecutado,
    l2CreditoComprometido: totales.value.l2Comprometido,
    l2CreditoEjecutado: totales.value.l2Ejecutado,
    l2CreditoNoEjecutado: totales.value.l2NoEjecutado,
    l3CreditoComprometido: totales.value.l3Comprometido,
    l3CreditoEjecutado: totales.value.l3Ejecutado,
    l3CreditoNoEjecutado: totales.value.l3NoEjecutado,
    l4CreditoComprometido: totales.value.l4Comprometido,
    l4CreditoEjecutado: totales.value.l4Ejecutado,
    l4CreditoNoEjecutado: totales.value.l4NoEjecutado,
    l5CreditoComprometido: totales.value.l5Comprometido,
    l5CreditoEjecutado: totales.value.l5Ejecutado,
    l5CreditoNoEjecutado: totales.value.l5NoEjecutado,
    // Totales generales
    totalCreditoComprometido: totales.value.totalComprometido,
    totalCreditoEjecutado: totales.value.totalEjecutado,
    totalCreditoNoEjecutado: totales.value.totalNoEjecutado,
  };

  columns.forEach((column, index) => {
    if (index === 0 || column.property === "comarca.nombre") {
      summaryRow[index] = "TOTAL";
    } else if (column.property && totalesMap[column.property] !== undefined) {
      summaryRow[index] = formatCurrency(totalesMap[column.property]);
    } else {
      summaryRow[index] = "";
    }
  });

  return summaryRow;
};

const cargaListado = ref(false);
const load = async () => {
  cargaListado.value = true;
  try {
    await module.fetchAll();
    search.value = "";
    currentPage.value = 1;
  } catch (error) {
    Swal.fire({
      text: t("tabla.justificacion2025.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
};

onBeforeMount(() => {
  load();
});

onActivated(async () => {
  cargaListado.value = true;
  try {
    await module.fetchAll();
  } catch (error) {
    Swal.fire({
      text: t("tabla.justificacion2025.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
});

onMounted(() =>
  setCurrentPageBreadcrumbs(t("menu.justificacion2025"), [
    t("menu.justificacion2025"),
  ])
);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("menu.justificacion2025")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("tabla.justificacion2025.numero", {
                numero: _unref(justificaciones).length,
              })), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              style: {"width":"300px"},
              placeholder: _ctx.$t('tabla.buscador.placeholder')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(JsonExcel, {
              data: _unref(filteredCollection),
              labels: csvLabels,
              fields: _unref(csvFields),
              name: csvName
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_7, [
                  _createElementVNode("i", {
                    class: "fas fa-file-excel fs-3",
                    title: _ctx.$t('tabla.profesionalesListado.boton.imprimir')
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _: 1
            }, 8, ["data", "fields"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(result),
            style: {"width":"100%"},
            stripe: "",
            "default-sort": { prop: 'comarcaNombre', order: 'ascending' },
            onSortChange: sortChange,
            "show-summary": "",
            "summary-method": getSummaries
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.justificacion2025.comarca'),
                prop: "comarca.nombre",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.totalComprometido'),
                prop: "totalCreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.totalCreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.totalEjecutado'),
                prop: "totalCreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.totalCreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.totalNoEjecutado'),
                prop: "totalCreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.totalCreditoNoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l1CreditoComprometido'),
                prop: "l1CreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l1CreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l1CreditoEjecutado'),
                prop: "l1CreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l1CreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l1CreditoNoEjecutado'),
                prop: "l1CreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(
                  (scope.row.l1CreditoComprometido || 0) -
                    (scope.row.l1CreditoEjecutado || 0)
                )), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l2CreditoComprometido'),
                prop: "l2CreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l2CreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l2CreditoEjecutado'),
                prop: "l2CreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l2CreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l2CreditoNoEjecutado'),
                prop: "l2CreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(
                  (scope.row.l2CreditoComprometido || 0) -
                    (scope.row.l2CreditoEjecutado || 0)
                )), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l3CreditoComprometido'),
                prop: "l3CreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l3CreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l3CreditoEjecutado'),
                prop: "l3CreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l3CreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l3CreditoNoEjecutado'),
                prop: "l3CreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(
                  (scope.row.l3CreditoComprometido || 0) -
                    (scope.row.l3CreditoEjecutado || 0)
                )), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l4CreditoComprometido'),
                prop: "l4CreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l4CreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l4CreditoEjecutado'),
                prop: "l4CreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l4CreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l4CreditoNoEjecutado'),
                prop: "l4CreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(
                  (scope.row.l4CreditoComprometido || 0) -
                    (scope.row.l4CreditoEjecutado || 0)
                )), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l5CreditoComprometido'),
                prop: "l5CreditoComprometido",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l5CreditoComprometido)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l5CreditoEjecutado'),
                prop: "l5CreditoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(scope.row.l5CreditoEjecutado)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                align: "right",
                "header-align": "left",
                label: _ctx.$t('tabla.justificacion2025.l5CreditoNoEjecutado'),
                prop: "l5CreditoNoEjecutado",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(formatCurrency(
                  (scope.row.l5CreditoComprometido || 0) -
                    (scope.row.l5CreditoEjecutado || 0)
                )), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, cargaListado.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "my-5 float-end",
            background: "",
            "page-size": 25,
            layout: "prev, pager, next",
            total: _unref(filteredCollection).length,
            "hide-on-single-page": true,
            "current-page": _unref(currentPage),
            onCurrentChange: handleCurrentPageChange
          }, null, 8, ["total", "current-page"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})